module.exports = __webpack_public_path__ + "assets/events_crime_plain.5161a953.svg";